<template>
  <div :style="`min-height:${contentHeight}px`" class="position-relative">
    <div :style="`min-height:${contentHeight / 2}px`">
      <div>
        <div class="d-flex align-items-center">
          <span style="font-size: 14px; color: #606266">{{
            $l('INDEX.product_table_label_image') || '图片'
          }}</span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <div>
            <el-upload
              id="uploader"
              ref="uploader"
              multiple
              action="/oss/ossUploadReturnUrlAndFileId"
              :file-list="listImageFile"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onImageChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <el-button
                v-if="!disabled"
                class="ml-2"
                style="font-size: 14px;"
                type="text"
                >{{ $l('table_label_upload_image') || '上传图片' }}</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap block">
        <vuedraggable
          @end="draggableEnd"
          tag="div"
          draggable=".draggable-item"
          class="d-flex flex-wrap"
        >
          <div
            v-for="(item, index) in listImageView"
            :key="index"
            class="draggable-item"
          >
            <el-tooltip
              placement="top"
              :content="$l('tooltip_mouse_click_drag') || '鼠标点击拖动'"
            >
              <div class="image-box">
                <span
                  class="default-icon"
                  v-if="listImage[index].isDefaultImage"
                >
                  <i class="el-icon-success"></i>
                </span>
                <el-image
                  style="width: 100%; height: 100%"
                  fit="scale-down"
                  :src="item"
                  :preview-src-list="listImageView"
                ></el-image>
                <div
                  class="shadow d-flex align-items-center justify-content-center"
                >
                  <div>
                    <span @click="onImagePreview(index)">
                      <i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      v-if="!disabled"
                      @click="onImageCheck(index)"
                      class="ml-2"
                    >
                      <i class="el-icon-check"></i
                    ></span>
                    <span
                      v-if="!disabled"
                      @click="onImageDel(index)"
                      class="ml-2"
                    >
                      <i class="el-icon-delete-solid"></i>
                    </span>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </vuedraggable>
      </div>
      <div
        class="position-absolute"
        style="text-align: center;top: 40%;left: 40%;"
        v-if="!listImageView || !listImageView.length"
      >
        <img src="/image/static/img/nodata.png" />
        <p class="no-data">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImage"
        :src="item.displayImageUrl || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    sampleSetCode: String,
    disabled: { type: Boolean, default: false },
  },
  components: { vuedraggable },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadFileMaxLimit: 8,
    }
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 225
    },
    listImageView() {
      return this.listImage.map((image) => {
        return image.thumbImageUrl
      })
    },
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length
    },
  },
  mounted() {
    this.loadImages()
  },
  methods: {
    async loadImages() {
      this.listImage = []
      this.listImage = await this.getImageData(this.sampleSetCode)
    },
    async getImageData(sampleSetCode) {
      if (!sampleSetCode) return []

      return await this.$api
        .sampleSetImageListApi({ sampleSetCode })
        .then((res) => res.body.data)
    },
    onImagePreview(index) {
      // 点击大图显示图片预览组件
      if (this.listImage.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    onImageDel(index) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const image = this.listImage[index]
        const params = { sampleSetImgCode: image.sampleSetImgCode }
        this.loadingOpen()
        this.imageDel(params)
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status === 200) {
              this.loadImages()
            } else {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
            }
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    onImageCheck(index) {
      const image = this.listImage[index]
      const params = {
        sampleSetCode: this.sampleSetCode,
        sampleSetImgCode: image.sampleSetImgCode,
      }

      this.loadingOpen()
      this.setSampleDefaultImage(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_set_ok') || '设置成功！',
              type: 'success',
            })
            this.loadImages()
          } else {
            this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
        })
    },
    async setSampleDefaultImage(params) {
      return await this.$api.sampleSetImageDefaultImageApi(params)
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (newIndex === oldIndex) return
      const oldEl = { ...this.listImage[oldIndex] }
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listImage[i] = this.listImage[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = oldIndex; i < newIndex; i++) {
          this.listImage[i] = this.listImage[i + 1]
        }
      }
      this.listImage[newIndex] = oldEl
      this.updateSortOrder(this.listImage)
    },
    updateSortOrder(params) {
      this.loadingOpen()
      this.updateOrder(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            this.loadImages()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async updateOrder(params) {
      return await this.$api.sampleSetImageUpdateSortOrderApi({
        listImage: params,
      })
    },
    onImageChange(file) {
      //获取添加文件进来的状态
      if (file.status !== 'ready') return

      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (this.isEmpty) {
        this.$message.warning(this.$l('pe_select_upload_image'))
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.loadingClose()
        this.clearFiles()
        this.$message.error(this.$l('INDEX.uploader_label_status_error'))
        return
      }

      const params = { sampleSetCode: this.sampleSetCode, listImage }
      const res = await this.uploadInfoSave(params).catch(() => null)
      this.loadingClose()
      this.clearFiles()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.uploader_label_status_error'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success'),
        type: 'success',
      })
      this.loadImages()
    },
    uploadImages() {
      if (this.isEmpty) return Promise.resolve([])
      const uploadTask = this.listImageFile.map((image) => {
        return this.$api
          .SYS_UPLOAD(image.raw, 60000)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: image.raw.type,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
    async uploadInfoSave(params) {
      return await this.$api.sampleSetImageBatchUploadApi(params)
    },
    async imageDel(params) {
      return await this.$api.sampleSetImageDelApi(params)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.el-upload-list__item.is-ready {
  display: none;
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
